<template lang="pug">
  div()
    app-header()

    div(class='u-bg-primary')
      div(class='u-flex o-wrapper u-py5 u-flex-wrap u-items-start')
        div(class='u-white u-7/12@laptop u-6/12@tablet u-12/12')
          div(class='u-8/12@laptop u-10/12@tablet u-mx-auto u-px2')
            h2(class='u-fz-h0 u-line-1 u-mb3 u-mt4 u-mt0' data-aos='fade-right')
              span(class='u-color-secondary u-block') ¿Viajas a
              span(class='u-white u-block') Tacna?

            p(class='u-color-text u-mb0 u-mt0 u-fz-h4 u-mb4' data-aos='fade-right') Horarios flexibles, un equipo jóven, un gran ambiente y muchas oportunidades

            figure(class='u-m0 u-show@laptop ' data-aos='fade-right')
              img(src='/images/car_pavill.png')

        div(class='u-white u-5/12@laptop u-6/12@tablet u-12/12 u-flex-wrap u-flex' data-aos='fade-left')
          input-validate(
            v-model='form.firstname', :rule='rules.firstname' icon='user' placeholder='Nombres', :validation='toggleValidate'
            wrapper-class='c-input c-input--icon' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.lastname', :rule='rules.lastname' placeholder='Apellidos', :validation='toggleValidate'
            wrapper-class='c-input' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.email', :rule='rules.email' icon='message' placeholder='Correo electrónico', :validation='toggleValidate'
            wrapper-class='c-input c-input--icon' class='u-mb3 u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.whatsapp', :rule='rules.whatsapp' icon='location' placeholder='Whatsapp', :validation='toggleValidate'
            wrapper-class='c-input c-input--icon' class='u-mb3 u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          select-validate(
            v-model='form.countryId', :value='form.countryId', :rule='rules.countryId' placeholder='País', :validation='toggleValidate', :options='countries'
            wrapper-class='c-input u-bg-quaternary' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.origin', :rule='rules.origin' icon='location' placeholder='Origen', :validation='toggleValidate'
            wrapper-class='c-input c-input--icon' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          div(class='u-flex u-flex-wrap u-px2 u-items-center u-mb2')
            label(class='u-block u-mb2 u-mr4 u-color-text') ¿En que medio de transporte viajas?
            div(class='c-input u-flex u-items-center u-mr3 u-mb2')
              input(id='transport1' type='radio' name='transport' class='u-mr2', :value='1' v-model='form.transportId')
              label(class='c-input__label u-color-text' for='transport1') Avión

            div(class='c-input u-flex u-items-center u-mr3 u-mb2')
              input(id='transport2' type='radio' name='transport' class='u-mr2', :value='2' v-model='form.transportId')
              label(class='c-input__label u-color-text' for='transport2') Bus


          select-validate(v-if='form.transportId === 1'
            v-model='form.airlineCompany', :value='form.airlineCompany', :rule='rules.airlineCompany' placeholder='Empresa de aerolínea', :validation='toggleValidate', :options='airplanes'
            wrapper-class='c-input u-bg-quaternary' class='u-mb3 u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          select-validate(v-if='form.transportId === 2'
            v-model='form.busCompany', :value='form.busCompany', :rule='rules.busCompany' placeholder='Empresa de bus', :validation='toggleValidate', :options='buses'
            wrapper-class='c-input u-bg-quaternary' class='u-mb3 u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(v-if='form.transportId === 1'
            v-model='form.flightNumber', :rule='rules.flightNumber' placeholder='Número de vuelo', :validation='toggleValidate'
            wrapper-class='c-input' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          input-validate(
            v-model='form.checkinHour', :rule='rules.checkinHour' placeholder='Hora de llegada', :validation='toggleValidate'
            wrapper-class='c-input' class='u-mb3 u-6/12@tablet u-12/12 u-px2' error-class='u-pl3 u-ml2 u-color-warning u-fw-s-bold u-right-align')

          div(class='c-input u-flex u-items-center u-px2 u-mb2 u-12/12')
            input(id='invoice' type='checkbox' name='invoice' class='u-mr2', :value='2' v-model='form.invoice')
            label(class='c-input__label u-color-text' for='invoice') Deseo Factura

          div(class='u-px2 u-12/12')
            button(class='c-btn--primary u-12/12 u-fw-s-bold u-fz-h4 u-mt2' @click='postForm') Realizar Reserva

    div(class='u-py5')
      h3(class='u-mt0 u-mb4 u-fz-h1 u-center u-line-1' data-aos='fade-up')
        span(class='u-inline-block u-fw-light u-inline-block') Ven y Conoce&nbsp;
        span(class='u-color-secondary ') Tacna

      p(class='o-wrapper u-center u-mb5' data-aos='fade-up') Visita los principales puntos turísticos de nuestra ciudad, recorreremos la Alameda Bolognesi, Plaza de Armas apreciando el Arco Parabólico y Pileta Ornamental, Catedral, Parque de la Locomotora, Mezquita Musulmana, Zona Franca de Tacna, los principales mercadillos de la ciudad y los principales hoteles de la ciudad. Contamos con una amplia variedad de vehículos adaptándonos a sus necesidades. Infórmate más de nuestros servicios ¡Llamanos!

      div(class='o-wrapper')
        div(class='u-relative u-6/12@tablet u-mx-auto u-px4 u-12/12'  data-aos='fade-up')
          swiper(:options='swiperGallery' class='u-mx2')
            swiper-slide(v-for='(attraction, index) in attractions', :key='index' style='height:auto')
              img(:src='attraction.imageUrl', :title='attraction.name' class='u-br32')

          button(class='c-btn-nav c-btn-nav--prev c-btn-nav--white' id='gallery-prev')
            i(class='u-icon') arrow_left
          button(class='c-btn-nav c-btn-nav--next c-btn-nav--white' id='gallery-next')
            i(class='u-icon') arrow_right

    section(class='o-wrapper u-center u-pb5')
      h4(class='u-color-primary u-fw-bold u-fz-h4 u-center o-wrapper u-mt0' data-aos='fade-up') ¿Qué esperas?
      a(class='c-btn--primary u-px5 u-fw-bold u-inline-flex u-items-center' href="#"  v-scroll-to="'#root'" data-aos='fade-up') Realiza tu reserva

    app-footer
    loading(message='Enviando' v-if='isLoading')
    modal-confirm(v-if='isShowModalConfirm' @hide='isShowModalConfirm = false')
    modal-error(v-if='isShowModalError' @hide='isShowModalError = false')
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import Validator from 'validatorjs'

  export default {
    name: 'ReserveScreen',
    data () {
      return {
        isShowModalConfirm: false,
        isShowModalError: false,
        toggleValidate: false,
        clearForm: false,
        formValidate: false,
        isLoading: false,
        form: {
          firstname: '',
          lastname: '',
          email: '',
          whatsapp: '',
          origin: '',
          countryId: 0,
          transportId: 1,
          airlineCompany: 0,
          flightNumber: '',
          busCompany: 0,
          checkinHour: '',
          invoice: false
        },
        rules: {
          firstname: 'required|name',
          lastname: 'required|name',
          email: 'required|email',
          whatsapp: 'required|phone',
          origin: 'required',
          countryId: 'min:1',
          airlineCompany: 'min:1',
          flightNumber: 'required',
          busCompany: 'min:0',
          checkinHour: 'required'
        },
        countries: [
          {
            id: 1,
            name: 'Perú'
          },
          {
            id: 2,
            name: 'Chile'
          }
        ],
        airplanes: [],
        buses: [],
        attractions: [],
        swiperGallery: {
          slidesPerView: 1,
          autoplay: 5000,
          prevButton: '#gallery-prev',
          nextButton: '#gallery-next'
        }
      }
    },

    computed: {
      ...mapGetters({
        company: 'company'
      })
    },

    methods: {
      postForm () {
        this.validate()

        if (this.formValidate && !this.isLoading) {
          this.isLoading = true
          axios.post(`https://radiotaxipavill.ddns.net:8015/enlacepavill/RegistrarReserva.php`, this.form)
          axios.post(`${window.API_URL}/reservation`, this.form)
            .then((response) => {
              this.isShowModalConfirm = true
              this.isLoading = false
              this.form = {
                firstname: '',
                lastname: '',
                email: '',
                whatsapp: '',
                origin: '',
                countryId: 0,
                transportId: 1,
                airlineCompany: 0,
                flightNumber: '',
                busCompany: 0,
                checkinHour: '',
                invoice: false
              }
              this.clearForm = true
            })
            .catch(({response}) => {
              this.isLoading = false
              this.isShowModalError = true
            })
        }
      },

      validate () {
        let validation = new Validator(this.form, this.rules)
        validation.passes()
        this.formValidate = validation.passes()
        this.toggleValidate = !this.toggleValidate
        console.log(validation)
      },

      getAttractions () {
        axios.get(`${window.API_URL}/attractions`)
          .then(({data}) => {
            this.attractions = data.data
          })
      },

      getAirplanes () {
        axios.get(`${window.API_URL}/airplanes`)
          .then(({data}) => {
            this.airplanes = data.data
          })
      },

      getBuses () {
        axios.get(`${window.API_URL}/buses`)
          .then(({data}) => {
            this.buses = data.data
          })
      }
    },

    created () {
      this.getAttractions()
      this.getAirplanes()
      this.getBuses()
    },

    watch: {
      'form.transportId' (val) {
        if (val === 2) {
          this.rules.busCompany = 'min:1'

          this.rules.airlineCompany = 'min:0'
          this.form.airlineCompany = 0

          this.rules.flightNumber = ''
          this.form.flightNumber = ''
        } else {
          this.rules.busCompany = 'min:0'
          this.form.busCompany = 0

          this.rules.airlineCompany = 'min:1'
          this.rules.flightNumber = 'required'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/screens/Reserve/components/ReserveScreen.vue